import { Moon, Sun, Users } from "lucide-react";

const PLANS = [
  { id: "60", title: "One-on-One Session", length: "1 hour", price: "$35", icon: Sun, cta: "Request a Session",
    text: "A full hour, just you and me, for deep healing, reading or guidance." },
  { id: "30", title: "One-on-One Session", length: "30 minutes", price: "$25", icon: Moon, cta: "Request a Session",
    text: "A focused half hour for a clear message, a check-in or a gentle reset." },
  { id: "group", title: "Group Sessions", length: "Gather together", price: "Free", icon: Users, cta: "Join a Group Session",
    text: "Come heal, learn and grow in community. Donations are welcome, never required." },
];

export const Pricing = ({ onBook, onGroup }) => (
  <section id="pricing" data-testid="pricing-section" className="px-6 md:px-16 py-24 md:py-32">
    <div className="max-w-2xl">
      <p className="eyebrow">Sacred exchange</p>
      <h2 className="font-display gold-text text-4xl md:text-5xl mt-3">Sessions &amp; Pricing</h2>
      <p className="mt-5 text-base md:text-lg text-[#f7f1e1]/80">Any service can be held as a one-on-one session. Group gatherings are free, with love offerings welcome.</p>
    </div>
    <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-14">
      {PLANS.map(({ id, title, length, price, icon: Icon, cta, text }, i) => (
        <div key={id} className={`glass card-hover rounded-[1.5rem] p-8 md:p-9 flex flex-col rise ${i === 1 ? "md:mt-10" : ""}`} style={{ animationDelay: `${i * 120}ms` }} data-testid={`pricing-card-${id}`}>
          <div className="w-14 h-14 rounded-full border border-[#d4af37]/50 flex items-center justify-center text-gold mb-6"><Icon size={20} strokeWidth={1.5} /></div>
          <h3 className="font-cinzel text-xl text-[#f1d57a]">{title}</h3>
          <p className="font-cinzel text-xs tracking-[0.25em] uppercase text-[#f7f1e1]/60 mt-2">{length}</p>
          <p className="font-display gold-text text-5xl mt-6" data-testid={`pricing-price-${id}`}>{price}</p>
          {id === "group" && <p className="text-sm text-[#f1d57a]/80 mt-1 italic">donations welcome</p>}
          <p className="mt-5 text-[#f7f1e1]/75 leading-relaxed flex-1">{text}</p>
          <button className={`mt-8 self-start ${id === "group" ? "btn-ghost" : "btn-gold"}`} data-testid={`pricing-cta-${id}`}
            onClick={() => (id === "group" ? onGroup() : onBook(id))}>{cta}</button>
        </div>
      ))}
    </div>
  </section>
);
